<template>
  <div class="driver-report-info">
    <div class="search-form-box">
      <el-row :gutter="30">
        <!-- 新增 label-width 固定标签宽度 -->
        <el-form inline label-width="70px">
          <el-col :span="5">
            <el-form-item label="搜索:">
              <el-input
                style="width: 100%"
                v-model="searchForm.keyword"
                placeholder="请输入司机姓名或手机号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="上报时间:">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.reportDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                autocomplete="off"
                placeholder="请选择" />
            </el-form-item>
          </el-col>
          <el-col :span="5" v-if="companyType === '1'">
            <el-form-item label="分公司:">
              <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                <el-option
                  v-for="item in belongCompanyData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属服务商:">
              <el-select style="width: 100%" clearable v-model="searchForm.companyId" placeholder="请选择">
                <el-option
                  v-for="item in supplierData"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="车辆状态:">
              <el-select style="width: 100%" clearable v-model="searchForm.reportStatus" placeholder="请选择">
                <el-option
                  v-for="item in $dict.reportStatusOptions"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="出发城市:">
              <el-input style="width: 100%" v-model="searchForm.startCityName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="终点城市:">
              <el-input style="width: 100%" v-model="searchForm.endCityName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="">
              <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
              <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <div class="statistics-box">
      <div class="statistics-list">
        <el-image :src="statisticsImage1" class="statistics-image"></el-image>
        <div class="statistics-num">
          <div class="num">{{overviewData.scheduleNum}}</div>
          <div class="txt">排班司机数量</div>
        </div>
      </div>
      <div class="statistics-list">
        <el-image :src="statisticsImage2" class="statistics-image"></el-image>
        <div class="statistics-num">
          <div class="num">{{overviewData.reportedNum}}</div>
          <div class="txt">司机上报数量</div>
        </div>
      </div>
      <div class="statistics-list">
        <el-image :src="statisticsImage2" class="statistics-image"></el-image>
        <div class="statistics-num">
          <div class="num">{{overviewData.unreportedNum}}</div>
          <div class="txt">未上报司机数量</div>
        </div>
      </div>
      <div class="statistics-list">
        <el-image :src="statisticsImage1" class="statistics-image"></el-image>
        <div class="statistics-num">
          <div class="num">{{overviewData.ratio}}%</div>
          <div class="txt">上报率</div>
        </div>
      </div>
    </div>
    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:startCityName="{ row }">{{row.startCityName}}-{{row.endCityName}}</template>
        <template v-slot:reportStatus="{ row }">
          <span class="common-status status-cancel" v-if="row.reportStatus === 2">装满发车</span>
          <span class="common-status status-confirm" v-if="row.reportStatus === 1">接单中</span>
          <span class="common-status status-pending-order" v-if="row.reportStatus === 0">未上报</span>
        </template>
      </custom-table>
    </div>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import {getReportOverview, getReportPage} from "../api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import detail from "../detail.vue";
import {getSelectSupplier} from "@/views/SystemManagement/ServiceManagement/api";
import dayjs from "dayjs"
export default {
  name: "Staff-management",
  mixins: [tableMixin],
  components: {
    CustomCityCascader,
    detail,
    CustomTabBox,
    OperateBox,
    CustomTable,
  },
  data() {
    return {
      getTableMethod: getReportPage,
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      supplierData: [],
      overviewData: {},
      searchForm: {
        "companyId": "",
        "belongCompanyId": "",
        "endCityName": "",
        "keyword": "",
        "reportDate": dayjs().format('YYYY-MM-DD'),
        "reportStatus": "",
        "startCityName": ""
      },
      tableColumn: [
        {
          label: "司机姓名",
          prop: "username",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          show: true,
        },
        {
          label: "所属服务商",
          prop: "companyName",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          show: true,
        },
        {
          label: "上报线路",
          prop: "startCityName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "车辆状态",
          prop: "reportStatus",
          scopeStatus: true,
          show: true,
        },
        {
          label: "上报时间",
          prop: "reportTime",
          show: true,
        },
        {
          label: "上报地点",
          prop: "address",
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/siji_sb.png"),
    };
  },
  watch: {
    "searchForm.belongCompanyId":function(val) {
      this.searchForm.companyId = "";
      this.getSelectSupplierData(val)
    }
  },
  mounted() {
    // this.getSelectSupplierData()
    this.getOverviewData()
  },
  methods: {
    getOverviewData() {
      getReportOverview(this.searchForm).then(response => {
        if (response.code === 200) {
          this.overviewData = response.data
        }
      })
    },
    getSelectSupplierData(val) {
      getSelectSupplier({
        belongCompanyId: val,
        keyword: '',
      }).then(response => {
        if (response.code === 200) {
          this.supplierData = response.data
        }
      })
    },
    openDetail(type) {
      this.$refs.detail.init(type);
    },
  },
};
</script>

<style lang="scss" scoped>
.driver-report-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }
  .custom-table-box {
    //padding-bottom: 0.68rem;
  }
  .statistics-box {
    display: flex;
    justify-content: space-around;
    padding: 0 0.16rem;
    margin: 0 -0.1rem;
    .statistics-list {
      width: 33.33%;
      height: 1.2rem;
      background-color: #ffffff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem;
      box-sizing: border-box;
      margin: 0 0.1rem;
      .statistics-image {
        width: 0.8rem;
        height: 0.61rem;
      }
      .statistics-num {
        .num {
          font-size: 0.24rem;
          color: #000000;
          font-weight: bold;
        }
        .txt {
          font-size: 0.14rem;
          color: #434343;
          padding-top: 0.1rem;
        }
      }
    }
  }
  .tab-check-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem;
    box-sizing: border-box;
  }

  /* ========== 核心修复样式 ========== */
  .search-form-box {
    ::v-deep .el-form-item {
      margin-bottom: 0 !important;
      display: flex !important;
      align-items: center !important;
      min-height: 40px;
    }
    ::v-deep .el-form-item__label {
      white-space: nowrap;
    }
    ::v-deep .el-select,
    ::v-deep .el-date-picker,
    ::v-deep .el-input {
      box-sizing: border-box;
    }
  }
}
</style>
